import { AxiosError } from 'axios';

/**
 * Shape of the unified backend ResponseEntity for error responses.
 */
interface BackendErrorResponse {
  success: boolean;
  status: string;
  data: unknown;
  errorMessage: string | null;
}

/**
 * Extracts a human-readable error message from an Axios error.
 * Handles the new unified backend ResponseEntity shape:
 *   { success: false, status: "400 BAD_REQUEST", data: null, errorMessage: "..." }
 * Falls back to the legacy { message: "..." } shape and then to a generic fallback.
 */
export function extractErrorMessage(error: unknown, fallback = 'An unexpected error occurred.'): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as Partial<BackendErrorResponse> | undefined;

    if (data?.errorMessage) {
      return data.errorMessage;
    }

    // Legacy fallback: { message: "..." }
    if (data && 'message' in data && typeof (data as any).message === 'string') {
      return (data as any).message;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
}
